<template>
  <span>
    <NavigationLinkComponent
      :item="item"
      :class="$style.root"
    />
  </span>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})
</script>

<style module>
.root {
  composes: reset-root from global;
}

.root:hover {
}

.root[data-current-route],
.root:global(.router-link-active) {
  text-decoration-line: underline;
}
</style>
